<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12" :label="$t('name')">
                    <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input :class="errors[0] ? 'is-invalid' : ''" v-model="form.name" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('code')">
                            <b-form-input :class="errors[0] ? 'is-invalid' : ''" v-model="form.code" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="type" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('type')">
                            <multi-selectbox
                                v-model="form.type"
                                :multiple="false"
                                :options="typeOptions"
                                :validateError="errors[0]"></multi-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                variant="primary"
                class="btn-lg mr-2">
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import ParameterService from "@/services/ParameterService";
// Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        MultiSelectbox
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formLoading: false,
            form: {
                code: null,
                name: null,
                name_en: null,
                type: null
            },

            typeOptions: [
                {
                    text: 'string',
                    value: 'string',
                },
                {
                    text: 'file',
                    value: 'file',
                },
            ]
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            this.formLoading = true;
            ParameterService.get(id)
                .then((response) => {
                    this.form = response.data.data;
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.$toast.error(this.$t("api." + error.data.message));
                    }
                }).finally(()=>{
                this.formLoading = false;
            });
        },
        async updateForm() {
            if(this.checkPermission('parameter_update')) {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading=true;
                    ParameterService.update(this.formId, this.form)
                        .then((response) => {
                            this.formLoading = false;
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$emit("updateFormSuccess")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        }).finally(() => {
                        this.formLoading = false;
                    })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
